import React, { useCallback } from 'react'
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	makeStyles
} from '@material-ui/core'
import { formatNumsToDollars } from '../../../utils'
import { dangers, gray } from '../../../utils/colors'

const useStyles = makeStyles(() => ({
	title: {
		marginBottom: 24
	},
	dialogActions: {
		marginTop: 24,
		justifyContent: 'flex-start'
	}
}))

const ACTIONS = {
	Confirm: 'confirm',
	Cancel: 'cancel'
}

const FailedChargesWarningDialog = ({ isShown, setFailedChargesActionTaken, amountInCents, style }) => {
	const classes = useStyles()

	const handleActionTaken = useCallback(
		(action) => {
			if (setFailedChargesActionTaken) {
				setFailedChargesActionTaken(action)
			}
		},
		[setFailedChargesActionTaken]
	)

	return (
		<Dialog
			open={isShown}
			style={style && { ...style }}
			onClose={() => handleActionTaken(ACTIONS.Cancel)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle className={classes.title}>ARE YOU SURE?</DialogTitle>
			<DialogContent>
				<Typography variant="body1">
					Changing the payment method on an account with failed payments will automatically cause all of
					those failed charges (totaling {formatNumsToDollars(amountInCents)}) to run. Please notify the
					client of this before you continue.
				</Typography>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					color="secondary"
					style={{
						backgroundColor: dangers[500],
						color: gray[100]
					}}
					onClick={() => handleActionTaken(ACTIONS.Confirm)}>
					{ACTIONS.Confirm}
				</Button>
				<Button variant="outlined" color="secondary" onClick={() => handleActionTaken(ACTIONS.Cancel)}>
					{ACTIONS.Cancel}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default FailedChargesWarningDialog
